import { useCallback, useEffect, useState } from 'react';

import {
  useGetProjectFilters,
  useGetProjectManagerOptions,
  useGetProjectStatusOptions,
} from 'src/pages/ProjectsPage/api';
import AdvancedFilters, {
  AdvancedFiltersProps,
  AdvancedFiltersState,
} from 'src/components/AdvancedFilters';
import { useGetCityIdOptions } from 'src/pages/CandidatesPage/api';

export function ProjectFilters({
  open,
  filters,
  handleSearch,
}: AdvancedFiltersProps) {
  const [advancedFilters, setAdvancedFilters] = useState<
    AdvancedFiltersState[]
  >([{}]);

  useEffect(() => {
    setAdvancedFilters(filters.length ? filters : [{}]);
  }, [open, filters]);

  const { data: ProjectFilters } = useGetProjectFilters({ enabled: open });
  const { data: cityIdOptions } = useGetCityIdOptions({ enabled: open });
  const { data: projectStatusOptions } = useGetProjectStatusOptions({
    enabled: open,
  });
  const { data: projectManagerOptions } = useGetProjectManagerOptions({
    enabled: open,
  });

  const dynamicOptions = useCallback(
    (options: { version: string; uri: string }) => {
      if (options.uri === '/cities') {
        return cityIdOptions;
      }
      if (options.uri === '/project_statuses') {
        return projectStatusOptions;
      }
      if (options.uri === '/project_managers') {
        return projectManagerOptions;
      }
    },
    [cityIdOptions, projectStatusOptions, projectManagerOptions],
  );

  return (
    <AdvancedFilters
      open={open}
      data={ProjectFilters}
      filters={advancedFilters}
      handleSearch={handleSearch}
      setFilters={setAdvancedFilters}
      dynamicOptions={dynamicOptions}
    />
  );
}
